"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SubscriptionFilter model module.
 * @module model/SubscriptionFilter
 * @version 1.1.3-alpha.1
 */
class SubscriptionFilter {
  /**
   * Constructs a new <code>SubscriptionFilter</code>.
   * @alias module:model/SubscriptionFilter
   */
  constructor() {
    SubscriptionFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SubscriptionFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionFilter} obj Optional instance to populate.
   * @return {module:model/SubscriptionFilter} The populated <code>SubscriptionFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('subscription_type_id')) {
        obj['subscription_type_id'] = _ApiClient.default.convertToType(data['subscription_type_id'], 'String');
      }
      if (data.hasOwnProperty('is_cancelled')) {
        obj['is_cancelled'] = _ApiClient.default.convertToType(data['is_cancelled'], 'Boolean');
      }
      if (data.hasOwnProperty('is_active')) {
        obj['is_active'] = _ApiClient.default.convertToType(data['is_active'], 'Boolean');
      }
      if (data.hasOwnProperty('is_expired')) {
        obj['is_expired'] = _ApiClient.default.convertToType(data['is_expired'], 'Boolean');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SubscriptionFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubscriptionFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['subscription_type_id'] && !(typeof data['subscription_type_id'] === 'string' || data['subscription_type_id'] instanceof String)) {
      throw new Error("Expected the field `subscription_type_id` to be a primitive type in the JSON string but got " + data['subscription_type_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {Number} id
 */
SubscriptionFilter.prototype['id'] = undefined;

/**
 * @member {String} customer_id
 */
SubscriptionFilter.prototype['customer_id'] = undefined;

/**
 * @member {String} subscription_type_id
 */
SubscriptionFilter.prototype['subscription_type_id'] = undefined;

/**
 * @member {Boolean} is_cancelled
 */
SubscriptionFilter.prototype['is_cancelled'] = undefined;

/**
 * @member {Boolean} is_active
 */
SubscriptionFilter.prototype['is_active'] = undefined;

/**
 * @member {Boolean} is_expired
 */
SubscriptionFilter.prototype['is_expired'] = undefined;

/**
 * @member {String} q
 */
SubscriptionFilter.prototype['q'] = undefined;
var _default = exports.default = SubscriptionFilter;